import React, { Component } from 'react';
import mapImage from '../../assets/images/map.png';

class LocationMap extends Component {
    render() {
        return (
            <>
                <div className="footer bottom_cross1">
                    <div className="container">
                        <div className="row">                            
                            <div className="col-md-12">
                                <div className="map">
                                    {/* <div className="parallax"></div> */}
                                    <figure><img src={mapImage} alt="..." /></figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default LocationMap;